import * as React from 'react'
import { useTemplateActions } from './useTemplate'

// 🎯 NO PROPS! All actions come from template context
const TemplateActions = () => {
	const { saveTemplate, saveAsNewTemplate } = useTemplateActions()

	const handleSaveClick = () => {
		saveTemplate({ includeCurrentContent: true })
	}

	const handleSaveAsNewClick = () => {
		saveAsNewTemplate() // Uses default name generation
	}

	return (
		<div className="template-actions-container">
			<button onClick={handleSaveClick} className="button-secondary">
				Save Template
			</button>
			<button onClick={handleSaveAsNewClick} className="button-primary">
				Save as New Template
			</button>
		</div>
	)
}

export default TemplateActions
